export const defaultValues = {
  email: '',
  emailWc: '',
  isPartial: false,
  dispatchID: '',
  id: '',
  status: [],
  contractID: '',
  paymentID: '',
  companyCode: '',
  vendor: { id: '', value: '', label: 'All vendors' },
  modelNumber: '',
  priceMin: '',
  priceMax: '',
  orderDateMin: null,
  orderDateMax: null,
  orderID: '',
}

export const defaultStatus = []